/*
 * @Description: Do not edit
 * @Author: Do not edit
 * @Date: 2019-10-27 16:30:12
 * @LastEditTime: 2019-10-30 18:00:06
 * @LastEditors: he.jianbo
 */
/**
 * author: Qian.qianchen 2018-11-13
 * weibo模块
 */
'use strict';
angular
    .module('editingCenterWeiBoModule', [
        'editingCenterWeiBoLeftModule',
        'weiboRouterModule',
        'editingCenterWeiBoServiceModule',
        'weiboAttentionModule',
        'weiboCollectModule',
        'weiboCommentModule',
        'weiboMeModule',
        'weiboMyWeiBoModule',
        'weiboPendingModule',
        'weiboSignedModule',
        'weiboTimingSignedModule',
        'weiboToBeCompiledModule',
        'weiboSinaEmojiModule',
        'weiboPictureViewModule',
        'weiboVideoViewModule',
        'weiboTextTransferEmojiModule',
        'weiboEditPageModule', // 微博融合编辑页
        'wbPreviewModule', // 微博融合详情页
        'editWeiboDraftBoxRouterModule', // 微博废稿箱路由
        'editWeiboDraftBoxModule',
        'weiboContentModule' // 微博内容提出公共的
    ])
    .controller('editingCenterWeiBoController', [])
    .value('weiboConst', {
        listenStroageKey: 'Weibo',
        docTypeJsons: [{
            name: '全部',
            value: '',
        }, {
            name: '微博',
            value: '16'
        }, {
            name: '头条文章',
            value: '17'
        }],
        doctype: {
            '17': 'weiboheadlinesedit', // 微博头条文章
            '16': 'weiboedit' // 微博
        },
        params: {
        },
        list: {
            FGD_EDITINFO: [], // 发稿单编辑信息
            FGD_AUTHINFO: [{ isCreate: true }], // 发稿单作者信息
            ISNOPAYMENT: '1', // 是否发稿费，默认不发稿费
            TITLE: '',
            ORIGINAL: 0, // 原创稿件
            SPECIALDOC: 0, // 特殊稿件
            METADATAID: '0', // 稿件id
            CHNLDOCID: '0', // 渠道id
            ORIGINALTYPE: '',
            serviceid: 'mlf_appmetadata', // 执行保存操作时的方法
            SIGNATUREAUTHOR: '', // 署名作者
            NEWSSOURCES: '', // 稿件来源
        },
    });
